export type ChallengeType = "solo" | "team" | "quiz";
